import axios from "axios";
import {
  authHeader,
  authHeaderWithMultipartData,
} from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API;

class BookingService {
  // BOOKING RELATED APIs

  // Get booking list by filter
  getBookingByFilterList(query_str = "") {
    return axios
      .get(API_URL + "booking/business-date-wise" + query_str, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  /**
   *
   * @param {Booking} filter
   * @returns KIOSK GUEST RELATED SERVICE
   */
  // Get Kiosk booking list by filter
  async getKioskBooking(filter = "") {
    return await axios
      .get(API_URL + "guest/kiosk/list" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async createKioskGuest(data) {
    return await axios
      .post(API_URL + "guest/kiosk/list", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  async kioskGuestDetails(id) {
    return await axios
      .get(API_URL + "guest/kiosk/detail/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  async updateKioskGuest(id, data) {
    return await axios
      .patch(API_URL + "guest/kiosk/detail/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  async deleteKioskGuest(id) {
    return await axios
      .delete(API_URL + "guest/kiosk/detail/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Get booking details
  getBookingDetails(booking_id) {
    return axios
      .get(API_URL + "booking/detail/" + booking_id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get email log list of booking
  getEmailLogListOfBooking(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/email-log", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get room number availability by room type
  getRoomNoAvailabilityByRoomType(filter_date) {
    return axios
      .get(API_URL + "room/room-number/available" + filter_date, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Create bulk booking
  createBulkBooking(data) {
    return axios
      .post(API_URL + "booking/excl", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get bulk booking
  getBulkBooking() {
    return axios
      .get(API_URL + "booking/excl", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Download  bulk booking excel
  deleteExcelFile(bulk_booking_id) {
    return axios
      .delete(API_URL + "booking/excl/" + bulk_booking_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Create post booking
  createPostBooking(data) {
    return axios
      .post(API_URL + "post-booking", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Create booking
  createBooking(data) {
    return axios
      .post(API_URL + "booking/create", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Search guest for  booking
  findGuest(data) {
    return axios
      .get(API_URL + "booking/guest/search?search=" + data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update booking
  updateBooking(booking_id, data) {
    return axios
      .patch(API_URL + "booking/update/" + booking_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add guest in booking
  guestInBooking(booking_id, data) {
    return axios
      .post(API_URL + "booking/" + booking_id + "/guest", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add additional charge
  addAdditionalCharge(booking_id, data) {
    return axios
      .post(API_URL + "booking/" + booking_id + "/additional-charge", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Charge transaction settle
  transactionSettle(booking_id, data) {
    return axios
      .patch(
        API_URL + "booking/" + booking_id + "/charge-transaction-settel",
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Booking payments list
  getBookingWisePayments(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/charge-transaction", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  bookingSDPayment(booking_id, payment_id, data) {
    return axios
      .patch(
        API_URL + "booking/" + booking_id + "/security-deposit/" + payment_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  bookingPaymentAuthNow(booking_id, data) {
    return axios
      .patch(
        API_URL + "booking/" + booking_id + "/charge-transaction-settel",
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  bookingPaymentReleaseAmount(booking_id, payment_id, data) {
    return axios
      .patch(
        API_URL + "booking/" + booking_id + "/charge-transaction/" + payment_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  bookingPaymentCaptureAmount(booking_id, payment_id, data) {
    return axios
      .patch(
        API_URL + "booking/" + booking_id + "/charge-transaction/" + payment_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Send pre check in link
  bookingPreCheckInLink(booking_id, data) {
    return axios
      .patch(API_URL + "booking/" + booking_id + "/send-mail", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get booking transaction
  getTransaction(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/transaction", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // FOLIO RELATED APIs

  // Folio list
  getFolioList(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/folio", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Create folio
  createFolio(booking_id, data) {
    return axios
      .post(API_URL + "booking/" + booking_id + "/folio", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update folio
  editFolio(booking_id, folio_id, data) {
    return axios
      .patch(API_URL + "booking/" + booking_id + "/folio/" + folio_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete folio
  deleteFolio(booking_id, folio_id) {
    return axios
      .delete(API_URL + "booking/" + booking_id + "/folio/" + folio_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get all transactions
  getTransactionList(booking_id, filter = "") {
    return axios
      .get(API_URL + "booking/" + booking_id + "/transaction" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get all transactions not used in folio
  getTransactionListNotInFolio(booking_id, filter = "") {
    return axios
      .get(
        API_URL +
          "booking/" +
          booking_id +
          "/transaction-not-in-folio" +
          filter,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Add transaction in folio
  transactionInFolio(booking_id, transaction_id, data) {
    return axios
      .post(
        API_URL +
          "booking/" +
          booking_id +
          "/folio/" +
          transaction_id +
          "/transaction-move",
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  // Move transaction over folios
  moveFolioTransaction(booking_id, transaction_id, data) {
    return axios
      .post(
        API_URL +
          `booking/${booking_id}/folio/${transaction_id}/transaction-move`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // UPSELL ORDER RELATED APIs

  // Add upsell order
  addUpsellOrder(booking_id, data) {
    return axios
      .post(API_URL + "booking/" + booking_id + "/upsell-order", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update upsell order
  updateUpsellOrder(booking_id, upsell_id, data) {
    return axios
      .patch(
        API_URL + "booking/" + booking_id + "/upsell-order/" + upsell_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Get upsell order list
  getUpsellOrderByFilter(filter) {
    return axios
      .get(API_URL + "booking/upsell-order" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  //NIGHT AUDIT

  // Get Night audit list
  getNightAuditList(filter = "") {
    return axios
      .get(API_URL + "booking/night-audit" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get last night audit
  getLatNightAudit(query) {
    return axios
      .get(API_URL + "booking/night-audit" + query, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // start night audit
  nightAuditAdd(data) {
    return axios
      .post(API_URL + "booking/night-audit", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // UNUSED APIs

  // Get booking list
  getBookingList(query_str = "") {
    return axios
      .get(API_URL + "booking/list" + query_str, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Get booking list with room
  getBookingWithRoomList(query_str) {
    return axios
      .get(API_URL + "booking-with-room" + query_str, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Get booking details by reference
  getBookingDetailsByReference(reference) {
    return axios
      .get(API_URL + "find-booking/kiosk" + reference, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get custom question list of booking
  getCustomQuestionListOfBooking(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/additional-question", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //get payment list of booking
  getPaymentListOfBooking(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/payment", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  bookingPaymentStatusChange(booking_id, payment_id, data) {
    return axios
      .patch(
        API_URL + "booking/" + booking_id + "/charge-transaction/" + payment_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Get room allotment
  getRoomAllotment(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/room-allotment", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update room based on room type
  updateRoomListByRoomType(booking_id, allotment_id, data) {
    return axios
      .patch(
        API_URL + "booking/" + booking_id + "/room-allotment/" + allotment_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }
  // folio details
  getFolioDetails(booking_id, folio_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/folio/" + folio_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get upsell order list
  getUpsellOrder(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/upsell-order", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // SHORT URL RELATED APIs

  // Create long to short URL
  createShortUrl(data) {
    return axios
      .post(API_URL + "hotel-setting/url-shorten", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new BookingService();
